import { React } from 'react';
import {
    firebaseAuth,
    firebaseFire as Libfirebase,
    firebaseStorage
} from '../helpers/firebase-config.js';
import { Timestamp } from 'firebase/firestore';


export function getMessages(conversaID, conversaOBJ) {
    return new Promise(async function (resolve, reject) {
        //caso seja uma nova conversa
        if (!conversaID) {
            //verifica se não existe o documento já            
            await Libfirebase.collection("conversas")
                .where("users", "array-contains", conversaOBJ.user1.id).get().then(obj => {
                    if (obj.docs.length > 0) {
                        let buscaConversa = obj.docs.filter(x => (x.data().users[1] === conversaOBJ.user2.id && x.data().users[0] === conversaOBJ.user1.id) || (x.data().users[0] === conversaOBJ.user2.id && x.data().users[1] === conversaOBJ.user1.id));
                        if (buscaConversa.length > 0) {
                            conversaID = buscaConversa[0].id;
                        }
                    }
                });
            //caso realmente não encontre o doc ele cria
            if (!conversaID) {
                await Libfirebase.collection("conversas").add(conversaOBJ).then(retornoID => {
                    conversaID = retornoID.id
                });
            }
        }
        const list = Libfirebase.collection('conversas')
            .doc(conversaID).collection("mensagens");

        resolve({ id: conversaID, list });
    });
}

// export function corri() {


//     Libfirebase.collection("paciente").get().then(async (val) => {

//         for (let us of val.docs) {
//             let obj = us.data();

//             await Libfirebase.collection('usuario').doc(obj.cpf).get().then(usu => {
//                 if (!usu.exists) {
//                     Libfirebase.doc("usuario/" + obj.cpf).set({
//                         CPF: obj.cpf,
//                         ativo: true,
//                         email: "_" + obj.email,
//                         nome: obj.nome,
//                         permissao: "3",
//                         profissao: "Paciente",
//                         senha: obj.cpf.substring(0, 6),
//                         avatarURL: 'https://firebasestorage.googleapis.com/v0/b/globalbrain-ba498.appspot.com/o/images%2Fno-user.jpg?alt=media&token=44616cc9-46e2-40ea-906f-28e46f58fb68'
//                     });
//                 }
//                 else {

//                 }
//             });
//         }
//     });
// }

export function getConversations(idUsuario, idPaciente = null) {
    // console.log("idPaciente", idPaciente)
    function subtractMonths(date, months) {
        date.setMonth(date.getMonth() - months);
        return date;
    }

    return new Promise(function (resolve, reject) {
        const dateAux = subtractMonths(new Date(), 3);
        let time = Timestamp.fromDate(dateAux)

        try {
            let ref = Libfirebase.collection('conversas')
            if (idPaciente) {
                // console.log("caiu no 1")
                ref = ref.where('users', 'array-contains', idPaciente)
            } else {
                // console.log("caiu no 2")
                ref = ref.where('users', 'array-contains', idUsuario)
                    .where('mensagem.data_envio', '>=', time)
            }
            resolve(ref);
        } catch (ex) {
            reject(ex);
        }
    });
}

export function updateConversa(conversaID, obj) {
    Libfirebase.doc("conversas/" + conversaID).set(obj, { merge: true });
}
export function updateMessage(conversaID, messageID, obj) {
    Libfirebase.doc("conversas/" + conversaID + "/mensagens/" + messageID).set(obj, { merge: true });
}

export async function getUsuarios() {
    return new Promise(async function (result, reject) {
        let lista = [];

        Libfirebase.collection("usuario").get().then(async (val) => {
            for (let us of val.docs) {
                let obj = us.data();

                // Libfirebase.collection("usuario").where('CPF','==',obj.cpf).get().then(usu=>{                
                //     if(usu.exists){
                //         obj.avatarURL = usu.data().avatarURL;
                //     }                
                // });
                lista.push(obj);
            }
            lista = lista.sort(function (a, b) {
                if (a.nome.trim() > b.nome.trim()) {
                    return 1;
                } else if (a.nome.trim() < b.nome.trim()) {
                    return -1;
                } else
                    return 0;
            })

            result(lista);
        });
    });
}

export async function getUsuariosAlgolia(busca) {
    // algolia
    const algoliasearch = require("algoliasearch");
    const client = algoliasearch("S4T1I4OXWN", "01bed30f13ef39976e5b4204eba41be4");
    const index = client.initIndex("usuario");

    return new Promise(async function (result, reject) {

        index.search(busca)
            .then(({ hits }) => {
                // console.log(hits);
                let lista = hits;
                lista = lista.sort(function (a, b) {
                    if (a.nome.trim() > b.nome.trim()) {
                        return 1;
                    } else if (a.nome.trim() < b.nome.trim()) {
                        return -1;
                    } else
                        return 0;
                })
                result(lista);
            })
    });
}

export function getConversationsCount(tipo, idUsuario) {
    return new Promise(function (resolve, reject) {
        try {
            if (tipo === "medico") {
                var ref = Libfirebase.doc(idUsuario);
                const list = Libfirebase
                    .collectionGroup("destinatarios")
                    .where('origem', '==', ref)
                    //.collection("mensagens")
                    .where("mensagem", "array-contains", false);

                resolve(list);
            } else {
                var ref = Libfirebase.doc(idUsuario);
                const list = Libfirebase.collectionGroup("destinatarios").where('destino', '==', ref).where("mensagem", "array-contains", "visualizado: false");
                resolve(list);
            }
        } catch (ex) {
            reject(ex);
        }

    });
}


export function getAvatarFromCPF(cpf) {
    return new Promise(function (resolve, reject) {
        const list = Libfirebase.collection('usuarios')
            .where('CPF', '==', cpf)
            .get().then(resp => resolve(resp));
    });
}


export function getRef(col, uid) {
    return new Promise(function (resolve, reject) {
        resolve(Libfirebase.collection(col).doc(uid));
    })
}
export async function getDocRef(id) {
    return new Promise(async function (resolve, reject) {
        await Libfirebase.doc(id).get().then(x => {
            resolve(x.ref);
        });
    })
}



export function saveMessage(conversa, mensagem, idConversa, path) {
    return new Promise(async function (resolve, reject) {

        if (!path) {
            let reff = null;
            await Libfirebase.doc("conversas/" + idConversa).collection("mensagens").add(mensagem).then(result => {

                result.set({
                    reference: result
                }, { merge: true });
                reff = result
            });
            if (conversa.mensagem) {

                // await getDocRef("conversas/" + idConversa + "/conversas/" + path).then(ref=>{
                //     reff = ref;
                // })
                conversa.mensagem.reference = reff;
                Libfirebase.collection("conversas").doc(idConversa).set(conversa, { merge: true });
            }

        } else {
            Libfirebase.doc(path).set(conversa, { merge: true }).collection("mensagens").add(mensagem);
        }


        resolve(path);

        // if (path) {
        //     await Libfirebase.doc(path).set(msg, { merge: true });
        // } else {
        //     await Libfirebase.collection("conversas")
        //         .doc(user)
        //         .collection("destinatarios")
        //         .doc(pac)
        //         .collection("mensagens")
        //         .add(msg).then(docref => {
        //             msg.idRef = docref.path;
        //             msg.idRefId = docref.id;
        //         });
        // }
        // await Libfirebase.collection("conversas")
        //     .doc(user)
        //     .collection("destinatarios")
        //     .doc(pac)
        //     .set({
        //         mensagem: msg
        //     }, { merge: true }).then(x => {
        //         resolve(msg.idRefId);
        //     });
    });
}

export async function getAtendimentosWhatsapp(patientRef) {
    const pac = Libfirebase.doc(patientRef)
    const snap = await Libfirebase.collectionGroup("wp_log").where('usuario', "==", pac).get()
    return snap.docs.map(e => { return { id: e.ref.id, ref: e.ref, ...e.data() } })
}

export function getUsuario(id) {
    return new Promise(function (resolve, reject) {
        Libfirebase.collection("usuario").doc(id).get().then((result) => {
            resolve(result.data());
        })
    })
}

